/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
var View = require('../../view/modal/CompleteInformation');
var Model = nb.define({
    parent:require('./Dialog'),
    method:{
        init:function () {
            this.set('modalName','complete-information');
            this.set('title','恭喜您成为ASC会员');
            this.onChange('onHide',function () {
                setTimeout(function (args) {
                    window.location.href = 'index.html';
                },500);
            },this);
        }
    }
});
var model = new Model();
var view = new View;
view.setModel(model);
nb.model.onChange(nb.opts.clientReady, function () {
    view.$().appendTo(document.body);
}, this);
module.exports = model;


//////////////////
// WEBPACK FOOTER
// ../src/js/model/modal/CompleteInformation.js
// module id = 81
// module chunks = 6 32 35 36